import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/movies';

interface CategoryTabsProps {
  activeSlug?: string;
}

export default function CategoryTabs({ activeSlug = 'all' }: CategoryTabsProps) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-4 mb-8">
      <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50 whitespace-nowrap">
        影视分类
      </h2>
      <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-1">
        {categories.map((cat) => (
          <button
            key={cat.slug}
            onClick={() => navigate(`/category/${cat.slug}`)}
            className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
              activeSlug === cat.slug
                ? 'bg-primary-500 text-foreground-50'
                : 'bg-background-100 text-foreground-300 hover:text-foreground-100 hover:bg-background-200/70 border border-background-200/50'
            }`}
          >
            <i className={`${cat.icon} text-xs`}></i>
            {cat.name}
          </button>
        ))}
      </div>
    </div>
  );
}